import styled, { css } from "styled-components";
import { styledByTheme } from "../../../../../themes/architecture/styled-by-theme";

const GenericSideMenuIconCommonBox = styled.div<{active?: boolean}>`
    box-sizing: border-box;
    margin: 0 1rem 0 0;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        margin: 0 2rem 0 0;
    }

    width: 2.4rem;
    height: 2.4rem;
    padding: 0.2rem;
    transition: color 0.2s ease, background-color 0.2s ease, border-bottom 0.2s ease;
`;

const GenericSideMenuIconDefaultBox = styled(GenericSideMenuIconCommonBox)`
    ${(props) => props.active ? css`
        background-color: ${(props) => props.theme.colors.textActive};
        color: ${(props) => props.theme.colors.backgroundDark};
    ` : null}
    border-radius: 50%;
`;

const GenericSideMenuIconHarrahsBox = styled(GenericSideMenuIconCommonBox)`
    ${(props) => props.active ? css`
        background-color: ${(props) => props.theme.colors.textActive};
        color: ${(props) => props.theme.colors.brandSecondary};
    ` : null}
    border-radius: 50%;
`;

const GenericSideMenuIconWsopBox = styled(GenericSideMenuIconCommonBox)`
    ${(props) => props.active ? css`
        background-color: ${(props) => props.theme.colors.textActive};
        color: ${(props) => props.theme.colors.backgroundDark};
    ` : null}
    border-radius: 50%;
`;

const GenericSideMenuIconSIBox = styled(GenericSideMenuIconCommonBox)`
    ${(props) => props.active ? css`
        color: ${(props) => props.theme.colors.textLight};
    ` : null}
`;

export const GenericSideMenuIconBox = styledByTheme(GenericSideMenuIconDefaultBox)
    .forCasino777(GenericSideMenuIconCommonBox)
    .forHarrahs(GenericSideMenuIconHarrahsBox)
    .forWsop(GenericSideMenuIconWsopBox)
    .forBallysDover(GenericSideMenuIconWsopBox)
    .forSI(GenericSideMenuIconSIBox)
    .apply();